import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { isLoggedIn, hasPermission, hasAnyPermission, hasMenu } from '@/utils/auth.js'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/UnifiedDeviceManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/datacenter-management',
    name: 'datacenter-management',
    component: () => import('../views/DataCenterManagementPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('../views/Monitoring.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: () => import('../views/Alerts.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/device-mount-management',
    name: 'device-mount-management',
    component: () => import('../views/DeviceMountManagement.vue'),
    meta: { requiresAuth: true, title: '设备上架管理' }
  },
  {
    path: '/mount-number-rules',
    name: 'mount-number-rules',
    component: () => import('../views/MountNumberRules.vue'),
    meta: { requiresAuth: true, title: '上架编号规则' }
  },
  {
    path: '/asset-number-rules',
    name: 'asset-number-rules',
    component: () => import('../views/AssetNumberRules.vue'),
    meta: { requiresAuth: true, title: '资产编号规则' }
  },
  {
    path: '/snmp',
    name: 'snmp',
    component: () => import('../views/SNMP.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mibs',
    name: 'mibs',
    component: () => import('../views/MIBs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mib-files',
    name: 'mib-files',
    component: () => import('../views/MIBFiles.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/oid-templates',
    name: 'oid-templates',
    component: () => import('../views/OIDTemplates.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/oid-template-groups',
    name: 'oid-template-groups',
    component: () => import('../views/OIDTemplateGroups.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/snmp-walk',
    name: 'snmp-walk',
    component: () => import('../views/SNMPWalk.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/graphs',
    name: 'graphs',
    component: () => import('../views/Graphs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/remote',
    name: 'remote',
    component: () => import('../views/Remote.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/discovery',
    name: 'discovery',
    component: () => import('../views/Discovery.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/scheduled-tasks',
    name: 'scheduled-tasks',
    component: () => import('../views/ScheduledTasks.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-platforms',
    name: 'ai-platforms',
    component: () => import('../views/AIPlatforms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-chat',
    name: 'ai-chat',
    component: () => import('../views/AIChat.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/asset-management',
    name: 'asset-management',
    component: () => import('../views/AssetManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/datacenter-3d',
    name: 'datacenter-3d',
    component: () => import('../views/DataCenter3D.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/datacenter-3d-test',
    name: 'datacenter-3d-test',
    component: () => import('../views/DataCenter3DTest.vue'),
    meta: { requiresAuth: true, menu: 'device:3d:test' }
  },
  {
    path: '/datacenter-3d-test1',
    name: 'datacenter-3d-test1',
    component: () => import('../views/DataCenter3DTest1.vue'),
    meta: { requiresAuth: true, menu: 'device:3d:test1' }
  },
  {
    path: '/datacenter-3d-digital-twin',
    name: 'datacenter-3d-digital-twin',
    component: () => import('../views/DataCenter3DDigitalTwin.vue'),
    meta: { requiresAuth: true, title: '数字孪生3D可视化', noTransition: true }
  },
  {
    path: '/digital-twin-fullscreen',
    name: 'digital-twin-fullscreen',
    component: () => import('../views/DigitalTwinFullscreen.vue'),
    meta: { requiresAuth: true, title: '数字孪生 - 全屏模式', noLayout: true, noTransition: true }
  },
  {
    path: '/ai-workflow',
    name: 'ai-workflow',
    component: () => import('../views/AIWorkflowDesigner.vue'),
    meta: { requiresAuth: true, title: 'AI 工作流设计器', noTransition: true }
  },
  {
    path: '/digital-twin-datacenter',
    name: 'digital-twin-datacenter',
    component: () => import('../views/DigitalTwinDataCenter.vue'),
    meta: { requiresAuth: true, title: '数字孪生机房', noTransition: true, menu: 'digitaltwin:datacenter' }
  },
  {
    path: '/log-server',
    name: 'log-server',
    component: () => import('../views/LogServer.vue'),
    meta: { requiresAuth: true, title: '日志服务器' }
  },
  {
    path: '/device-trace',
    name: 'device-trace-list',
    component: () => import('../views/DeviceTraceList.vue'),
    meta: { requiresAuth: true, title: '设备资产追溯' }
  },
  {
    path: '/device/:id/trace',
    name: 'device-trace',
    component: () => import('../views/DeviceTrace.vue'),
    meta: { requiresAuth: true, title: '设备资产追溯详情', noLayout: true }
  },
  {
    path: '/device/mount-no/:mountNo/trace',
    name: 'device-trace-by-mount-no',
    component: () => import('../views/DeviceTrace.vue'),
    meta: { requiresAuth: true, title: '设备资产追溯详情', noLayout: true }
  },
  // 系统管理路由
  {
    path: '/system/users',
    name: 'system-users',
    component: () => import('../views/system/UserManagement.vue'),
    meta: { requiresAuth: true, title: '用户管理' }
  },
  {
    path: '/system/roles',
    name: 'system-roles',
    component: () => import('../views/system/RoleManagement.vue'),
    meta: { requiresAuth: true, title: '角色管理' }
  },
  {
    path: '/system/permissions',
    name: 'system-permissions',
    component: () => import('../views/system/PermissionManagement.vue'),
    meta: { requiresAuth: true, title: '权限管理' }
  },
  {
    path: '/system/departments',
    name: 'system-departments',
    component: () => import('../views/system/DepartmentManagement.vue'),
    meta: { requiresAuth: true, title: '部门管理' }
  },
  {
    path: '/system/positions',
    name: 'system-positions',
    component: () => import('../views/system/PositionManagement.vue'),
    meta: { requiresAuth: true, title: '岗位管理' }
  },
  {
    path: '/system/dicts',
    name: 'system-dicts',
    component: () => import('../views/system/DictManagement.vue'),
    meta: { requiresAuth: true, title: '字典管理' }
  },
  {
    path: '/system/login-logs',
    name: 'system-login-logs',
    component: () => import('../views/system/LoginLog.vue'),
    meta: { requiresAuth: true, title: '登录日志' }
  },
  {
    path: '/system/operation-logs',
    name: 'system-operation-logs',
    component: () => import('../views/system/OperationLog.vue'),
    meta: { requiresAuth: true, title: '操作日志' }
  },
  {
    path: '/system/time-sync',
    name: 'system-time-sync',
    component: () => import('../views/system/TimeSync.vue'),
    meta: { requiresAuth: true, title: '时间同步' }
  },
  {
    path: '/system/settings',
    name: 'system-settings',
    component: () => import('../views/SystemSettings.vue'),
    meta: { requiresAuth: true, title: '系统设置' }
  },
  {
    path: '/system/open-api',
    name: 'system-open-api',
    component: () => import('../views/system/OpenApiTokenManagement.vue'),
    meta: { requiresAuth: true, title: '开放接口' }
  },
  // 个人中心
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/profile/UserProfile.vue'),
    meta: { requiresAuth: true, title: '个人中心' }
  },
  // 系统设置（用户级）
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SystemSettings.vue'),
    meta: { requiresAuth: true, title: '系统设置' }
  },
  // 工作流路由
  {
    path: '/workflow',
    name: 'workflow',
    component: () => import('../views/workflow/WorkflowManagement.vue'),
    meta: { requiresAuth: true, title: '工作流管理' }
  },
  {
    path: '/workflow/process-center',
    name: 'workflow-process-center',
    component: () => import('../views/workflow/ProcessCenter.vue'),
    meta: { requiresAuth: true, title: '流程中心' }
  },
  {
    path: '/workflow/low-code-platform',
    name: 'workflow-low-code-platform',
    component: () => import('../views/workflow/LowCodePlatform.vue'),
    meta: { requiresAuth: true, title: '低代码平台' }
  },
  {
    path: '/workflow/process-management',
    name: 'workflow-process-management',
    component: () => import('../views/workflow/ProcessManagement.vue'),
    meta: { requiresAuth: true, title: '流程管理' }
  },
  {
    path: '/workflow/monitoring',
    name: 'workflow-monitoring',
    component: () => import('../views/workflow/ProcessMonitoring.vue'),
    meta: { requiresAuth: true, title: '流程监控' }
  },
  {
    path: '/workflow/process-design',
    name: 'workflow-process-design',
    component: () => import('../views/workflow/ProcessDesignerPro.vue'),
    meta: { requiresAuth: true, title: '流程设计器' }
  },
  {
    path: '/workflow/form-management',
    name: 'workflow-form-management',
    component: () => import('../views/workflow/FormManagement.vue'),
    meta: { requiresAuth: true, title: '表单管理' }
  },
  {
    path: '/workflow/form-design',
    name: 'workflow-form-design',
    component: () => import('../views/workflow/FormDesignerPro.vue'),
    meta: { requiresAuth: true, title: '表单设计器' }
  },
  {
    path: '/workflow/tasks/pending',
    name: 'workflow-tasks-pending',
    component: () => import('../views/workflow/TaskPending.vue'),
    meta: { requiresAuth: true, title: '待办任务' }
  },
  {
    path: '/workflow/tasks/completed',
    name: 'workflow-tasks-completed',
    component: () => import('../views/workflow/TaskCompleted.vue'),
    meta: { requiresAuth: true, title: '已办任务' }
  },
  {
    path: '/workflow/tasks/cc',
    name: 'workflow-tasks-cc',
    component: () => import('../views/workflow/TaskCc.vue'),
    meta: { requiresAuth: true, title: '抄送任务' }
  },
  {
    path: '/workflow/processes/my',
    name: 'workflow-processes-my',
    component: () => import('../views/workflow/MyProcesses.vue'),
    meta: { requiresAuth: true, title: '我的流程' }
  },
  {
    path: '/workflow/processes/:id',
    name: 'workflow-process-detail',
    component: () => import('../views/workflow/ProcessDetail.vue'),
    meta: { requiresAuth: true, title: '流程详情' }
  },
  {
    path: '/workflow/process-form',
    name: 'workflow-process-form',
    component: () => import('../views/workflow/ProcessForm.vue'),
    meta: { requiresAuth: true, title: '发起流程' }
  },
  {
    path: '/workflow/task-form',
    name: 'workflow-task-form',
    component: () => import('../views/workflow/TaskForm.vue'),
    meta: { requiresAuth: true, title: '审批任务' }
  },
  {
    path: '/workflow/process-templates',
    name: 'workflow-process-templates',
    component: () => import('../views/workflow/ProcessTemplates.vue'),
    meta: { requiresAuth: true, title: '流程模板中心' }
  },
  {
    path: '/workflow/print/:instanceId',
    name: 'workflow-form-print',
    component: () => import('../views/workflow/FormPrint.vue'),
    meta: { requiresAuth: true, noLayout: true, title: '打印' }
  },
  {
    path: '/biz/:moduleKey/apply',
    name: 'biz-apply',
    component: () => import('../views/workflow/BizApply.vue'),
    meta: { requiresAuth: true, title: '业务申请' }
  },
  {
    path: '/biz/:moduleKey/list',
    name: 'biz-list',
    component: () => import('../views/workflow/BizList.vue'),
    meta: { requiresAuth: true, title: '业务列表' }
  },
  {
    path: '/monitoring-template',
    name: 'monitoring-template',
    component: () => import('../views/MonitoringTemplate.vue'),
    meta: { requiresAuth: true, title: '监控模板系统' }
  },
  {
    path: '/notification-templates',
    name: 'notification-templates',
    component: () => import('../views/NotificationTemplates.vue'),
    meta: { requiresAuth: true, title: '通知模板管理' }
  },
  {
    path: '/notification-config',
    name: 'notification-config',
    component: () => import('../views/NotificationConfig.vue'),
    meta: { requiresAuth: true, title: '通知配置管理' }
  },
  {
    path: '/recovery-events',
    name: 'recovery-events',
    component: () => import('../views/RecoveryEvents.vue'),
    meta: { requiresAuth: true, title: '恢复事件记录' }
  },
  // 设备组件管理路由
  {
    path: '/device-components/types',
    name: 'component-types',
    component: () => import('../views/device-components/ComponentTypeManagement.vue'),
    meta: { requiresAuth: true, title: '组件类型管理' }
  },
  {
    path: '/device-components/model-config/:modelId',
    name: 'device-model-config',
    component: () => import('../views/device-components/DeviceModelConfig.vue'),
    meta: { requiresAuth: true, title: '设备型号组件配置' }
  },
  // IPAM路由
  {
    path: '/ipam/vlans',
    name: 'ipam-vlans',
    component: () => import('../views/ipam/VLANManagement.vue'),
    meta: { requiresAuth: true, title: 'VLAN管理' }
  },
  {
    path: '/ipam/pools',
    name: 'ipam-pools',
    component: () => import('../views/ipam/IPPoolManagement.vue'),
    meta: { requiresAuth: true, title: 'IP地址池管理' }
  },
  // 网络设备管理路由
  {
    path: '/network-devices',
    name: 'network-devices',
    component: () => import('../views/network-devices/NetworkDeviceList.vue'),
    meta: { requiresAuth: true, title: '网络设备列表' }
  },
  // 运维办公路由
  {
    path: '/office/work-logs',
    name: 'work-logs',
    component: () => import('../views/office/WorkLogList.vue'),
    meta: { requiresAuth: true, title: '工作日志' }
  },
  {
    path: '/office/plans',
    name: 'work-plans',
    component: () => import('../views/office/WorkPlanList.vue'),
    meta: { requiresAuth: true, title: '工作计划' }
  },
  {
    path: '/office/todos',
    name: 'work-todos',
    component: () => import('../views/office/WorkTodoBoard.vue'),
    meta: { requiresAuth: true, title: '待办清单' }
  },
  // 网络拓扑路由
  {
    path: '/network-topology',
    name: 'network-topology',
    component: () => import('../views/network-topology/NetworkTopology.vue'),
    meta: { requiresAuth: true, title: '网络拓扑' }
  },
  {
    path: '/network-topology/g6',
    name: 'network-topology-g6',
    component: () => import('../views/network-topology/NetworkTopologyG6.vue'),
    meta: { requiresAuth: true, title: '网络拓扑 (G6)', menu: 'network:topology:2' }
  },
  {
    path: '/network-topology/3',
    name: 'network-topology-3',
    component: () => import('../views/NetworkTopology3.vue'),
    meta: { requiresAuth: true, title: '网络拓扑 3' }
  },
  // 设备类型同步配置路由
  {
    path: '/network-device-sync',
    name: 'network-device-sync',
    component: () => import('../views/network-device-sync/NetworkDeviceSync.vue'),
    meta: { requiresAuth: true, title: '设备类型同步配置' }
  },
  // 服务器管理路由
  {
    path: '/server-management',
    name: 'server-management',
    component: () => import('../views/ServerManagement.vue'),
    meta: { requiresAuth: true, title: '服务器管理' }
  },
  // 配线架管理路由
  {
    path: '/patch-panels',
    name: 'patch-panels',
    component: () => import('../views/PatchPanelManagement.vue'),
    meta: { requiresAuth: true, title: '配线架管理' }
  },
  {
    path: '/patch-panels/:id',
    name: 'patch-panel-detail',
    component: () => import('../views/PatchPanelDetailV2.vue'),
    meta: { requiresAuth: true, title: '配线架详情' }
  },
  {
    path: '/binding-records',
    name: 'binding-records',
    component: () => import('../views/BindingRecords.vue'),
    meta: { requiresAuth: true, title: '端口绑定记录' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = isLoggedIn()

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 云枢讯维`
  } else {
    document.title = '云枢讯维'
  }

  // 如果已登录但store中没有用户信息，尝试获取用户信息
  if (isAuthenticated && !store.getters.currentUser?.id) {
    try {
      const result = await store.dispatch('getUserInfo')
      if (!result.success) {
        // 获取用户信息失败，清除登录状态
        await store.dispatch('logout')
        next('/login')
        return
      }
    } catch (error) {
      // 获取用户信息失败，清除登录状态
      await store.dispatch('logout')
      next('/login')
      return
    }
  }

  // 需要登录的页面
  // 带上原目标地址（redirect），登录成功后可回到该页面。
  // 典型场景：手机扫描资产二维码打开 /device/:id/trace，未登录时先到登录页，
  // 登录后应自动跳回该资产的追溯详情，而不是回到仪表板。
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // 公开页面（如登录页）但已登录，跳转到首页
  if (to.meta.public && isAuthenticated) {
    next('/dashboard')
    return
  }

  // 检查菜单权限
  if (to.meta.requiresAuth && to.meta.menu) {
    if (!hasMenu(to.meta.menu)) {
      ElMessage.error('您没有访问该页面的权限')
      next('/dashboard')
      return
    }
  }

  // 检查特定权限
  if (to.meta.requiresAuth && to.meta.permission) {
    if (!hasPermission(to.meta.permission)) {
      ElMessage.error('您没有执行该操作的权限')
      next('/dashboard')
      return
    }
  }

  // 检查多个权限中的任意一个
  if (to.meta.requiresAuth && to.meta.permissions) {
    if (!hasAnyPermission(to.meta.permissions)) {
      ElMessage.error('您没有访问该页面的权限')
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
